export class AssignmentComment {
    createdBy: string;
    createdDate: Date;
    message: string;
    projectId: string;
    assignmentId: string;
    constructor(data: Partial<AssignmentComment> = {}) {
        this.createdBy = data.createdBy || '';
        this.createdDate = data.createdDate || new Date();
        this.message = data.message || '';
        this.projectId = data.projectId || '';
        this.assignmentId = data.assignmentId || '';
    }
}